import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CountryCode } from "../../pages/registration-pages/pricing-page/pricing.config";
import { catchError, Observable, of } from "rxjs";
import { map } from "rxjs/operators";

interface IpResponse {
  country_code: string;
  success: boolean;
}
@Injectable({
  providedIn: 'root',
})
export class CountryService {
  private readonly http = inject(HttpClient);

  getCountry(): Observable<CountryCode> {
    return this.http
      .get<IpResponse>('https://ipwho.is/')
      .pipe(
        map((response) => this.mapCountry(response.country_code)),
        catchError(() => of<CountryCode>('EU'))
      );
  }

  private mapCountry(code: string): CountryCode {
    switch (code) {
      case 'TN':
        return 'TN';

      case 'MA':
        return 'MA';

      case 'IN':
        return 'IN';

      default:
        return 'EU';
    }
  }
}